/* Food Tour Booking for Shopify (v2.1.0) — port of the WordPress widget 1.9.2.
   Reads the tour from the JSON block the section prints (#ftb-data), shows the
   calendar, guests and add-ons, then adds the booking to the Shopify cart and
   sends the customer to Shopify checkout. No dependencies. */
(function () {
  'use strict';

  var DATA = null;
  try { DATA = JSON.parse(document.getElementById('ftb-data').textContent); } catch (e) { DATA = null; }
  var CFG = (DATA && DATA.settings) || {};

  /* ------------------------------------------------------------------ *
   * Copy — edit here to change wording.
   * ------------------------------------------------------------------ */
  var T = {
    chooseDate: 'Choose a date',
    maxGuests: function (n) { return 'Small group, up to ' + n + ' guests'; },
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    pickHint: 'Dates in bold are available. Tap one to see the start time.',
    noDates: 'No dates are open for booking right now. Check back soon.',
    startsAt: 'Starts at',
    chooseTime: 'Choose a start time',
    groupType: 'Group',
    continue: 'Continue',
    stepOf: function (a, b) { return 'Step ' + a + ' of ' + b; },
    guestsTitle: 'Guests',
    guestsNote: function (n) { return 'Up to ' + n + ' guests per booking'; },
    each: 'each',
    addonsTitle: 'Add-ons',
    addonsNote: 'Optional',
    perPerson: 'per person',
    detailsTitle: 'Before you pay',
    dietary: 'Food restrictions or allergies',
    dietaryPh: 'e.g. vegetarian, no shellfish, nut allergy',
    optional: 'optional',
    promo: 'Promo code',
    promoHelp: 'The discount appears on the next page, before you pay.',
    total: 'Total',
    totalPrice: 'Total price',
    toCheckout: 'Continue to secure checkout',
    adding: 'Reserving your spot…',
    checkoutNote: 'You\u2019ll enter your details and pay on the next page.',
    close: 'Close',
    back: 'Back',
    loadError: 'Booking is unavailable right now. Refresh the page or contact us.',
    offline: 'Online booking isn\u2019t open for this experience right now. Write to us and we\u2019ll find a date for you.',
    cartError: 'We couldn\u2019t add this booking. Check your connection and try again.',
    expired: 'A booking in your cart was removed because its start time is too close. Choose a new date.',
    adult: ['adult', 'adults'],
    child: ['child', 'children'],
    weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    // Cart / checkout line labels (visible to the customer and in emails)
    propDate: 'Date',
    propTime: 'Time',
    propMeeting: 'Meeting point',
    propDietary: 'Food restrictions',
    propRef: 'Booking ref',
    propFor: 'For'
  };

  /* ------------------------------------------------------------------ *
   * Helpers
   * ------------------------------------------------------------------ */
  var ZERO_DEC = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];

  function h(tag, props) {
    var el = document.createElement(tag);
    props = props || {};
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') el.className = v;
      else if (k === 'text') el.textContent = v;
      else if (k.indexOf('on') === 0 && typeof v === 'function') el.addEventListener(k.slice(2).toLowerCase(), v);
      else if (k === 'value') el.value = v;
      else el.setAttribute(k, v === true ? '' : v);
    });
    for (var i = 2; i < arguments.length; i++) add(el, arguments[i]);
    return el;
  }
  function add(el, c) {
    if (c === null || c === undefined || c === false) return;
    if (Array.isArray(c)) { c.forEach(function (x) { add(el, x); }); return; }
    el.appendChild(typeof c === 'object' ? c : document.createTextNode(String(c)));
  }
  function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }

  function decimals(cur) { return ZERO_DEC.indexOf(cur) > -1 ? 0 : 2; }
  function round(n, cur) { var f = Math.pow(10, decimals(cur)); return Math.round(n * f) / f; }

  function money(amount, cur) {
    var d = decimals(cur);
    var parts = Number(amount).toFixed(d).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var s = parts.join('.');
    if (d && /\.00$/.test(s)) s = s.slice(0, -3);
    return cur + ' ' + s;
  }
  function shortPrice(amount, cur) {
    var frac = Math.round(amount * 100) % 100 !== 0 && decimals(cur) > 0;
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: frac ? 2 : 0, maximumFractionDigits: frac ? 2 : 0 }).format(amount);
    } catch (e) { return money(amount, cur); }
  }
  function plural(n, pair) { return n + ' ' + (n === 1 ? pair[0] : pair[1]); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(y, m, d) { return y + '-' + pad(m + 1) + '-' + pad(d); }
  function parseIso(s) { var p = s.split('-'); return { y: +p[0], m: +p[1] - 1, d: +p[2] }; }
  function longDate(s) {
    var p = parseIso(s);
    var wd = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][new Date(Date.UTC(p.y, p.m, p.d)).getUTCDay()];
    return wd + ', ' + p.d + ' ' + T.months[p.m] + ' ' + p.y;
  }
  function shortLongDate(s) { return longDate(s).replace(/ \d{4}$/, ''); }
  function timeLabel(t) {
    var p = String(t).split(':'), H = +p[0], M = +p[1];
    return (H % 12 || 12) + (M ? ':' + pad(M) : '') + (H >= 12 ? 'pm' : 'am');
  }
  function bookingRef() {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', s = '';
    for (var i = 0; i < 6; i++) s += chars.charAt(Math.floor(Math.random() * chars.length));
    return 'FT-' + s;
  }

  /* ---------- Time zones: each tour lives in its own ---------- */
  var fmtCache = {};
  function tzParts(ms, tz) {
    var f = fmtCache[tz] || (fmtCache[tz] = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }));
    var o = {};
    f.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = +p.value; });
    return { y: o.year, m: o.month - 1, d: o.day, H: o.hour === 24 ? 0 : o.hour, M: o.minute, S: o.second };
  }
  /** Wall-clock time in `tz` → UTC milliseconds. */
  function zonedToUtc(y, m, d, H, M, tz) {
    var wall = Date.UTC(y, m, d, H, M);
    var t = wall;
    for (var i = 0; i < 2; i++) {
      var p = tzParts(t, tz);
      var offset = Date.UTC(p.y, p.m, p.d, p.H, p.M, p.S) - t;
      t = wall - offset;
    }
    return t;
  }
  function validTz(tz) { try { new Intl.DateTimeFormat('en-US', { timeZone: tz }); return true; } catch (e) { return false; } }

  /** Bookable dates for one tier: { 'YYYY-MM-DD': ['HH:MM', …] } — same rules as the WordPress plugin. */
  function computeDates(cfg, tier, now) {
    var tz = cfg.timezone, out = {};
    var today = tzParts(now, tz);
    var closed = {};
    (cfg.closed || []).forEach(function (d) { closed[d] = true; });
    var cutoff = (Number(cfg.cutoff_hours) || 0) * 3600 * 1000;
    for (var i = 0; i <= (cfg.window_days || 180); i++) {
      var day = new Date(Date.UTC(today.y, today.m, today.d + i));
      var y = day.getUTCFullYear(), m = day.getUTCMonth(), d = day.getUTCDate();
      var key = iso(y, m, d);
      if (closed[key]) continue;
      var times = tier.schedule[day.getUTCDay()] || tier.schedule[String(day.getUTCDay())] || [];
      var open = times.filter(function (t) {
        var p = t.split(':');
        var start = zonedToUtc(y, m, d, +p[0], +p[1], tz);
        return start > now && start - now >= cutoff;
      });
      if (open.length) out[key] = open;
    }
    return out;
  }

  /* ---------- Shopify cart ---------- */
  function cartFetch(path, body) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(root + path, opts).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || T.cartError);
        return data;
      });
    }, function () { throw new Error(T.cartError); });
  }

  /* Analytics — optional, see section settings. Checkout events come from Shopify. */
  function track(data) {
    try {
      if (CFG.trackDataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: { currency: data.currency, value: data.value, items: [{ item_id: data.productId, item_name: data.productName, item_variant: data.date, price: data.value, quantity: 1 }] }
        });
      }
      if (CFG.trackMeta && typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', { content_ids: [data.productId], content_name: data.productName, content_type: 'product', value: data.value, currency: data.currency, num_items: data.guests });
      }
    } catch (e) { /* tracking never blocks booking */ }
  }

  function lockScroll(on) { document.documentElement.classList.toggle('fct-scroll-lock', on); }

  /* ------------------------------------------------------------------ *
   * Build the product model from the JSON the section printed
   * ------------------------------------------------------------------ */
  function buildProduct() {
    if (!DATA || !DATA.config) return null;
    if (DATA.config.bookable === false) return { offline: true };
    if (!DATA.config.tiers) return null;
    var c = DATA.config, cur = DATA.currency || 'USD';
    if (!validTz(c.timezone)) c.timezone = validTz(CFG.defaultTimezone) ? CFG.defaultTimezone : 'UTC';

    // Two layouts are supported: a single "Age Group" option (Adult / Child), or
    // "Group" (Shared / Private) + "Age Group" when the tour also sells private groups.
    function variant(list, group, guest) {
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (v.o2 === null || v.o2 === undefined || v.o2 === '') { if (v.o1 === guest) return v; }
        else if (v.o1 === group && v.o2 === guest) return v;
      }
      return null;
    }
    function addonVariant(list, name) {
      for (var i = 0; i < list.length; i++) if (list[i].o1 === name) return list[i];
      return null;
    }

    var tiers = [];
    c.tiers.forEach(function (t) {
      var a = variant(DATA.variants, t.label, c.adult_label);
      if (!a) return;
      var ch = t.has_child ? variant(DATA.variants, t.label, c.child_label) : null;
      tiers.push({
        id: t.id, label: t.label, schedule: t.schedule,
        adult: a.price / 100, adultVariant: a.id,
        child: ch ? ch.price / 100 : null, childVariant: ch ? ch.id : null
      });
    });
    if (!tiers.length) return null;

    var addons = [];
    (c.addons || []).forEach(function (a) {
      var v = addonVariant(DATA.addonVariants || [], a.name);
      if (v) addons.push({ id: a.id, name: a.name, per: a.per, description: a.description, price: v.price / 100, variant: v.id });
    });

    var now = Date.now();
    tiers.forEach(function (t) { t.dates = computeDates(c, t, now); });
    var tp = tzParts(now, c.timezone);

    return {
      id: c.id, name: c.name, currency: cur, capacity: c.capacity || 12,
      timezone: c.timezone, cutoff: Number(c.cutoff_hours) || 0,
      meeting_point: c.meeting_point || '',
      adult_label: 'Adults', child_label: 'Children',
      today: iso(tp.y, tp.m, tp.d),
      tiers: tiers, addons: addons
    };
  }

  /* ------------------------------------------------------------------ *
   * Widget
   * ------------------------------------------------------------------ */
  function Widget(root, product) {
    this.root = root;
    this.p = product;
    this.productId = product.id;
    this.s = this.freshState();
    this.s.tier = product.tiers[0].id;
    this.frame = 0;
    this.busy = false;
    this.refreshDates(true);
    this.renderInline();
  }

  Widget.prototype.freshState = function () {
    return { tier: null, date: null, time: null, adults: 1, children: 0, addons: {}, dietary: '', promo: '' };
  };

  Widget.prototype.tier = function () {
    var id = this.s.tier, list = this.p.tiers;
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  };

  Widget.prototype.refreshDates = function (resetView) {
    this.dates = this.tier().dates || {};
    var keys = Object.keys(this.dates).sort();
    this.firstDate = keys[0] || null;
    this.lastDate = keys[keys.length - 1] || null;
    if (this.s.date && !this.dates[this.s.date]) { this.s.date = null; this.s.time = null; }
    if (this.s.date && this.dates[this.s.date].indexOf(this.s.time) === -1) this.s.time = this.dates[this.s.date][0];
    if (resetView || !this.view || !this.firstDate) {
      var start = parseIso(this.firstDate || this.p.today);
      this.view = { y: start.y, m: start.m };
    }
  };

  Widget.prototype.dateInfo = function () { return this.s.date ? this.dates[this.s.date] : null; };
  Widget.prototype.guests = function () { return this.s.adults + this.s.children; };
  Widget.prototype.childrenAllowed = function () { var c = this.tier().child; return c !== null && c !== undefined; };
  Widget.prototype.chosenAddons = function () {
    var self = this;
    return this.p.addons.filter(function (a) { return !!self.s.addons[a.id]; });
  };
  /** Same numbers Shopify will charge: variant prices × quantities. */
  Widget.prototype.total = function () {
    if (!this.s.date) return 0;
    var t = this.tier(), g = this.guests();
    var sum = this.s.adults * t.adult + (this.childrenAllowed() ? this.s.children * t.child : 0);
    this.chosenAddons().forEach(function (a) { sum += a.per === 'person' ? a.price * g : a.price; });
    return round(sum, this.p.currency);
  };
  Widget.prototype.trackData = function () {
    return { currency: this.p.currency, value: this.total(), productId: this.p.id, productName: this.p.name, date: this.s.date, guests: this.guests() };
  };

  /* ---------- Inline calendar (desktop sidebar) ---------- */
  Widget.prototype.renderInline = function () {
    this.inModal = false;
    clear(this.root);
    var card = h('div', { class: 'fct-card' });
    card.appendChild(h('div', { class: 'fct-head' },
      h('h3', { class: 'fct-title' }, T.chooseDate),
      h('p', { class: 'fct-capacity' }, h('span', { class: 'fct-capacity-icon', 'aria-hidden': 'true' }), T.maxGuests(this.p.capacity))
    ));
    if (this.p.tiers.length > 1) card.appendChild(this.tierSwitch());
    if (!this.firstDate) {
      card.appendChild(h('p', { class: 'fct-empty' }, T.noDates));
      this.root.appendChild(card);
      return;
    }
    this.calEl = h('div', { class: 'fct-cal' });
    card.appendChild(this.calEl);
    this.selectEl = h('div', { class: 'fct-selection', 'aria-live': 'polite' });
    card.appendChild(this.selectEl);
    this.root.appendChild(card);
    this.renderCalendar();
    this.renderSelection();
  };

  Widget.prototype.tierSwitch = function () {
    var self = this;
    var wrap = h('div', { class: 'fct-tiers', role: 'group', 'aria-label': T.groupType });
    this.p.tiers.forEach(function (t) {
      var on = t.id === self.s.tier;
      wrap.appendChild(h('button', {
        type: 'button', class: 'fct-tier' + (on ? ' is-on' : ''), 'aria-pressed': String(on),
        onClick: function () {
          if (self.s.tier === t.id) return;
          self.s.tier = t.id;
          self.refreshDates(false);
          if (self.guests() > self.p.capacity) { self.s.adults = 1; self.s.children = 0; }
          if (!self.childrenAllowed()) self.s.children = 0;
          if (self.inModal) self.go(1); else self.renderInline();
        }
      }, h('span', { class: 'fct-tier-label' }, t.label), h('span', { class: 'fct-tier-price' }, shortPrice(t.adult, self.p.currency) + ' / ' + T.adult[0])));
    });
    return wrap;
  };

  Widget.prototype.renderCalendar = function () {
    var self = this, v = this.view, cur = this.p.currency, price = this.tier().adult;
    var cal = this.calEl;
    clear(cal);
    var today = parseIso(this.p.today);
    var last = parseIso(this.lastDate || this.p.today);
    var canPrev = (v.y * 12 + v.m) > (today.y * 12 + today.m);
    var canNext = (v.y * 12 + v.m) < (last.y * 12 + last.m);

    cal.appendChild(h('div', { class: 'fct-cal-nav' },
      h('button', { type: 'button', class: 'fct-icon-btn', 'aria-label': T.prevMonth, disabled: !canPrev, onClick: function () { self.shiftMonth(-1); } }, h('span', { class: 'fct-chev fct-chev--left', 'aria-hidden': 'true' })),
      h('div', { class: 'fct-cal-month', 'aria-live': 'polite' }, T.months[v.m] + ' ' + v.y),
      h('button', { type: 'button', class: 'fct-icon-btn', 'aria-label': T.nextMonth, disabled: !canNext, onClick: function () { self.shiftMonth(1); } }, h('span', { class: 'fct-chev fct-chev--right', 'aria-hidden': 'true' }))
    ));

    var ws = CFG.weekStart === 1 ? 1 : 0;
    var grid = h('div', { class: 'fct-cal-grid', role: 'group', 'aria-label': T.months[v.m] + ' ' + v.y });
    for (var i = 0; i < 7; i++) grid.appendChild(h('div', { class: 'fct-wd', 'aria-hidden': 'true' }, T.weekdays[(i + ws) % 7]));

    var firstDow = new Date(Date.UTC(v.y, v.m, 1)).getUTCDay();
    var blanks = (firstDow - ws + 7) % 7;
    for (var b = 0; b < blanks; b++) grid.appendChild(h('div', { class: 'fct-day fct-day--blank', 'aria-hidden': 'true' }));

    var daysInMonth = new Date(Date.UTC(v.y, v.m + 1, 0)).getUTCDate();
    for (var d = 1; d <= daysInMonth; d++) {
      (function (day) {
        var key = iso(v.y, v.m, day);
        var info = self.dates[key];
        var selected = self.s.date === key;
        var cls = 'fct-day' + (info ? ' is-open' : ' is-closed') + (selected ? ' is-selected' : '') + (key === self.p.today ? ' is-today' : '');
        grid.appendChild(h('button', {
          type: 'button', class: cls, disabled: !info, 'aria-pressed': info ? String(selected) : null,
          'aria-label': longDate(key) + (info ? ', ' + shortPrice(price, cur) : ', unavailable'),
          onClick: function () { self.selectDate(key); }
        },
          h('span', { class: 'fct-day-num' }, day),
          info ? h('span', { class: 'fct-day-price' }, shortPrice(price, cur)) : null
        ));
      })(d);
    }
    cal.appendChild(grid);
  };

  Widget.prototype.shiftMonth = function (delta) {
    var t = this.view.y * 12 + this.view.m + delta;
    this.view = { y: Math.floor(t / 12), m: t % 12 };
    this.renderCalendar();
  };

  Widget.prototype.selectDate = function (key) {
    this.s.date = key;
    this.s.time = this.dates[key][0];
    if (!this.childrenAllowed()) this.s.children = 0;
    this.renderCalendar();
    this.renderSelection();
  };

  Widget.prototype.renderSelection = function () {
    var self = this, el = this.selectEl;
    clear(el);
    var d = this.dateInfo();
    if (!d) {
      el.appendChild(h('p', { class: 'fct-hint' }, T.pickHint));
      if (this.inModal) { this.footer(null, T.continue, function () {}); this.primaryBtn.disabled = true; }
      return;
    }
    if (d.length > 1) {
      var times = h('div', { class: 'fct-times', role: 'group', 'aria-label': T.chooseTime });
      d.forEach(function (t) {
        var on = t === self.s.time;
        times.appendChild(h('button', {
          type: 'button', class: 'fct-time-opt' + (on ? ' is-on' : ''), 'aria-pressed': String(on),
          onClick: function () { self.s.time = t; self.renderSelection(); }
        }, timeLabel(t)));
      });
      el.appendChild(h('p', { class: 'fct-time-label' }, T.chooseTime));
      el.appendChild(times);
    } else {
      el.appendChild(h('div', { class: 'fct-time' },
        h('span', { class: 'fct-time-label' }, T.startsAt),
        h('span', { class: 'fct-time-value' }, timeLabel(d[0]))
      ));
    }
    if (this.inModal) {
      this.footer(null, T.continue, function () { self.go(2); });
      return;
    }
    el.appendChild(h('button', { type: 'button', class: 'fct-btn fct-btn--primary fct-btn--block', onClick: function () { self.openModal(); } }, T.continue));
  };

  /* ---------- Overlay ---------- */
  Widget.prototype.buildModal = function () {
    var self = this;
    this.backBtn = h('button', { type: 'button', class: 'fct-icon-btn', 'aria-label': T.back, onClick: function () { self.goBack(); } }, h('span', { class: 'fct-chev fct-chev--left', 'aria-hidden': 'true' }));
    this.stepEl = h('div', { class: 'fct-step' });
    this.closeBtn = h('button', { type: 'button', class: 'fct-icon-btn', 'aria-label': T.close, onClick: function () { self.closeModal(); } }, h('span', { class: 'fct-x', 'aria-hidden': 'true' }));
    this.contextEl = h('div', { class: 'fct-context' });
    this.bodyEl = h('div', { class: 'fct-body' });
    this.footEl = h('div', { class: 'fct-foot' });
    this.modal = h('div', { class: 'fct-modal', role: 'dialog', 'aria-modal': 'true', 'aria-label': this.p.name, tabindex: '-1' },
      h('div', { class: 'fct-modal-top' }, this.backBtn, this.stepEl, this.closeBtn),
      this.contextEl, this.bodyEl, this.footEl
    );
    this.overlay = h('div', { class: 'fct-root fct-overlay', onClick: function (e) { if (e.target === self.overlay) self.closeModal(); } }, this.modal);
    if (CFG.brand) this.overlay.style.setProperty('--fct-brand', CFG.brand);
    this.onKey = function (e) {
      if (e.key === 'Escape') { self.closeModal(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    };
    document.body.appendChild(this.overlay);
  };

  Widget.prototype.trapFocus = function (e) {
    var f = this.modal.querySelectorAll('button:not([disabled]), input, textarea, [href], [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Widget.prototype.openModal = function (frame) {
    if (!this.overlay) this.buildModal();
    this.lastFocus = document.activeElement;
    this.overlay.classList.add('is-open');
    lockScroll(true);
    document.addEventListener('keydown', this.onKey);
    if (frame === 'calendar') { this.fromCalendar = true; this.go(1); }
    else { this.fromCalendar = false; this.go(2); }
    this.modal.focus();
  };

  Widget.prototype.closeModal = function () {
    if (this.busy) return;
    this.overlay.classList.remove('is-open');
    lockScroll(false);
    document.removeEventListener('keydown', this.onKey);
    this.frame = 0;
    this.renderInline();
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Widget.prototype.goBack = function () {
    if (this.busy) return;
    if (this.frame === 2) { if (this.fromCalendar) this.go(1); else this.closeModal(); }
    else if (this.frame === 3) this.go(2);
  };

  Widget.prototype.go = function (frame) {
    this.frame = frame;
    this.closeBtn.disabled = false;
    this.backBtn.disabled = false;
    clear(this.bodyEl);
    clear(this.footEl);
    this.errorEl = null;
    this.modal.setAttribute('data-frame', frame);
    this.backBtn.style.visibility = 'visible';

    clear(this.contextEl);
    if (this.s.date && this.s.time && frame !== 1) {
      this.contextEl.appendChild(h('p', { class: 'fct-context-name' }, this.p.name + (this.p.tiers.length > 1 && this.p.tiers[0].id !== this.s.tier ? ' \u00b7 ' + this.tier().label : '')));
      this.contextEl.appendChild(h('p', { class: 'fct-context-when' }, shortLongDate(this.s.date) + ' at ' + timeLabel(this.s.time)));
    }

    var total = this.fromCalendar ? 3 : 2, offset = this.fromCalendar ? 0 : 1;
    this.stepEl.textContent = T.stepOf(frame - offset, total);

    if (frame === 1) this.frameCalendar();
    else if (frame === 2) this.frameGuests();
    else if (frame === 3) this.frameDetails();
    this.bodyEl.scrollTop = 0;
  };

  Widget.prototype.footer = function (summary, label, onClick) {
    clear(this.footEl);
    this.errorEl = h('p', { class: 'fct-error', role: 'alert', hidden: true });
    this.footEl.appendChild(this.errorEl);
    if (summary) this.footEl.appendChild(h('p', { class: 'fct-summary' }, summary));
    this.primaryBtn = h('button', { type: 'button', class: 'fct-btn fct-btn--primary fct-btn--block', onClick: onClick }, label);
    this.footEl.appendChild(this.primaryBtn);
  };

  Widget.prototype.cartLine = function () {
    var parts = [plural(this.s.adults, T.adult)];
    if (this.s.children) parts.push(plural(this.s.children, T.child));
    if (this.p.tiers.length > 1 && this.p.tiers[0].id !== this.s.tier) parts.push(this.tier().label);
    this.chosenAddons().forEach(function (a) { parts.push(a.name); });
    return parts.join(' \u00b7 ');
  };

  Widget.prototype.footerTotal = function (label, onClick, note) {
    this.footer(note || null, label, onClick);
    var row = h('div', { class: 'fct-total' },
      h('div', { class: 'fct-total-text' },
        h('span', { class: 'fct-total-label' }, T.totalPrice),
        h('span', { class: 'fct-total-cart' }, this.cartLine())
      ),
      h('span', { class: 'fct-total-amount' }, money(this.total(), this.p.currency))
    );
    this.footEl.insertBefore(row, this.primaryBtn);
  };

  Widget.prototype.showError = function (msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.hidden = !msg;
  };

  Widget.prototype.setBusy = function (on, label) {
    this.busy = on;
    if (!this.primaryBtn) return;
    this.primaryBtn.disabled = on;
    this.primaryBtn.classList.toggle('is-loading', on);
    if (label) this.primaryBtn.textContent = label;
    this.closeBtn.disabled = on;
    this.backBtn.disabled = on;
  };

  /* ---------- Frame 1 (overlay): calendar, for the mobile button ---------- */
  Widget.prototype.frameCalendar = function () {
    var self = this;
    this.inModal = true;
    this.backBtn.style.visibility = 'hidden';
    this.bodyEl.appendChild(h('div', { class: 'fct-head' },
      h('h3', { class: 'fct-title' }, this.p.name),
      h('p', { class: 'fct-capacity' }, h('span', { class: 'fct-capacity-icon', 'aria-hidden': 'true' }), T.maxGuests(this.p.capacity))
    ));
    if (this.p.tiers.length > 1) this.bodyEl.appendChild(this.tierSwitch());
    if (!this.firstDate) {
      this.bodyEl.appendChild(h('p', { class: 'fct-empty' }, T.noDates));
      this.footer(null, T.close, function () { self.closeModal(); });
      return;
    }
    this.calEl = h('div', { class: 'fct-cal' });
    this.bodyEl.appendChild(this.calEl);
    this.selectEl = h('div', { class: 'fct-selection', 'aria-live': 'polite' });
    this.bodyEl.appendChild(this.selectEl);
    this.renderCalendar();
    this.renderSelection();
  };

  /* ---------- Frame 2: guests & add-ons ---------- */
  Widget.prototype.frameGuests = function () {
    var self = this, cur = this.p.currency, tier = this.tier(), max = this.p.capacity;
    var body = this.bodyEl;
    var steppers = [];

    function stepper(key, label, price, min) {
      var countEl = h('span', { class: 'fct-count', 'aria-live': 'polite' }, self.s[key]);
      var minus = h('button', { type: 'button', class: 'fct-step-btn', 'aria-label': 'Remove one ' + label.toLowerCase(), onClick: function () { change(-1); } }, '\u2212');
      var plus = h('button', { type: 'button', class: 'fct-step-btn', 'aria-label': 'Add one ' + label.toLowerCase(), onClick: function () { change(1); } }, '+');
      function change(delta) {
        var next = self.s[key] + delta;
        if (next < min || (delta > 0 && self.guests() >= max)) return;
        self.s[key] = next;
        refresh();
      }
      steppers.push(function () {
        countEl.textContent = self.s[key];
        minus.disabled = self.s[key] <= min;
        plus.disabled = self.guests() >= max;
      });
      return h('div', { class: 'fct-row' },
        h('div', { class: 'fct-row-text' },
          h('span', { class: 'fct-row-title' }, label),
          h('span', { class: 'fct-row-sub' }, money(price, cur) + ' ' + T.each)
        ),
        h('div', { class: 'fct-stepper' }, minus, countEl, plus)
      );
    }

    body.appendChild(h('section', { class: 'fct-section' },
      h('div', { class: 'fct-section-head' }, h('h4', {}, T.guestsTitle), h('span', { class: 'fct-muted' }, T.guestsNote(max))),
      stepper('adults', this.p.adult_label, tier.adult, 1),
      this.childrenAllowed() ? stepper('children', this.p.child_label, tier.child, 0) : null
    ));

    if (this.p.addons.length) {
      var list = h('section', { class: 'fct-section' },
        h('div', { class: 'fct-section-head' }, h('h4', {}, T.addonsTitle), h('span', { class: 'fct-muted' }, T.addonsNote))
      );
      this.p.addons.forEach(function (a) {
        var id = 'fct-addon-' + self.p.id + '-' + a.id;
        var input = h('input', { type: 'checkbox', id: id, class: 'fct-check' });
        input.checked = !!self.s.addons[a.id];
        input.addEventListener('change', function () {
          if (input.checked) self.s.addons[a.id] = true; else delete self.s.addons[a.id];
          refresh();
        });
        list.appendChild(h('label', { class: 'fct-addon', for: id },
          input,
          h('span', { class: 'fct-checkmark', 'aria-hidden': 'true' }),
          h('span', { class: 'fct-addon-text' },
            h('span', { class: 'fct-row-title' }, a.name),
            a.description ? h('span', { class: 'fct-row-sub' }, a.description) : null
          ),
          h('span', { class: 'fct-addon-price' }, '+ ' + money(a.price, cur) + (a.per === 'person' ? ' ' + T.perPerson : ''))
        ));
      });
      body.appendChild(list);
    }

    function refresh() {
      steppers.forEach(function (fn) { fn(); });
      self.footerTotal(T.continue, function () { self.go(3); });
    }
    refresh();
  };

  /* ---------- Frame 3: food restrictions, promo code → cart → checkout ---------- */
  Widget.prototype.frameDetails = function () {
    var self = this, body = this.bodyEl, pid = this.p.id;

    var diet = h('textarea', { id: 'fct-dietary-' + pid, class: 'fct-input', rows: '3', maxlength: '500', placeholder: T.dietaryPh });
    diet.value = this.s.dietary;
    diet.addEventListener('input', function () { self.s.dietary = diet.value; });

    var promo = h('input', { id: 'fct-promo-' + pid, class: 'fct-input fct-input--promo', type: 'text', autocomplete: 'off', autocapitalize: 'characters', spellcheck: 'false' });
    promo.value = this.s.promo;
    promo.addEventListener('input', function () { self.s.promo = promo.value; });
    promo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });

    body.appendChild(h('section', { class: 'fct-section' },
      h('div', { class: 'fct-section-head' }, h('h4', {}, T.detailsTitle)),
      h('div', { class: 'fct-field' },
        h('label', { for: diet.id, class: 'fct-label' }, T.dietary, h('span', { class: 'fct-muted' }, ' (' + T.optional + ')')),
        diet
      ),
      CFG.showPromo !== false ? h('div', { class: 'fct-field' },
        h('label', { for: promo.id, class: 'fct-label' }, T.promo, h('span', { class: 'fct-muted' }, ' (' + T.optional + ')')),
        promo,
        h('p', { class: 'fct-help' }, T.promoHelp)
      ) : null
    ));

    function submit() { self.addToCart(); }
    this.footerTotal(T.toCheckout, submit, T.checkoutNote);
  };

  Widget.prototype.addToCart = function () {
    var self = this, t = this.tier(), p = this.p;
    var ref = bookingRef();
    var tp = this.s.time.split(':'), dp = parseIso(this.s.date);
    var startUtc = new Date(zonedToUtc(dp.y, dp.m, dp.d, +tp[0], +tp[1], p.timezone)).toISOString();
    var when = longDate(this.s.date);
    var at = timeLabel(this.s.time) + ' (local time)';

    var base = {};
    base[T.propDate] = when;
    base[T.propTime] = at;
    if (p.meeting_point) base[T.propMeeting] = p.meeting_point;
    base[T.propRef] = ref;
    base._ftb_ref = ref;
    base._ftb_tour = p.id;
    base._ftb_start = startUtc;
    base._ftb_cutoff = String(p.cutoff);

    function props(extra) { var o = {}; for (var k in base) o[k] = base[k]; for (var e in extra) o[e] = extra[e]; return o; }

    var items = [];
    var adultProps = props({});
    if (this.s.dietary.trim()) adultProps[T.propDietary] = this.s.dietary.trim();
    items.push({ id: t.adultVariant, quantity: this.s.adults, properties: adultProps });
    if (this.s.children && this.childrenAllowed()) items.push({ id: t.childVariant, quantity: this.s.children, properties: props({}) });
    var g = this.guests();
    this.chosenAddons().forEach(function (a) {
      var ap = {};
      ap[T.propFor] = p.name + ' \u2013 ' + shortLongDate(self.s.date);
      ap[T.propRef] = ref;
      ap._ftb_ref = ref; ap._ftb_start = startUtc; ap._ftb_cutoff = String(p.cutoff);
      items.push({ id: a.variant, quantity: a.per === 'person' ? g : 1, properties: ap });
    });

    this.showError('');
    this.setBusy(true, T.adding);
    track(this.trackData());

    var clearFirst = CFG.clearCart !== false ? cartFetch('cart/clear.js', {}) : Promise.resolve();
    clearFirst.then(function () {
      return cartFetch('cart/add.js', { items: items });
    }).then(function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var code = (self.s.promo || '').trim();
      window.location.href = code
        ? root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout')
        : root + 'checkout';
    }).catch(function (err) {
      self.setBusy(false, T.toCheckout);
      self.showError(err && err.message ? err.message : T.cartError);
    });
  };

  /* ------------------------------------------------------------------ *
   * Remove bookings whose start time is now inside the cutoff window.
   * Runs on tour pages here; ftb-cart-guard.js runs it on every page.
   * ------------------------------------------------------------------ */
  function guardCart() {
    return cartFetch('cart.js').then(function (cart) {
      var now = Date.now(), stale = {}, updates = {}, any = false;
      cart.items.forEach(function (it) {
        var pr = it.properties || {};
        if (!pr._ftb_start) return;
        var start = Date.parse(pr._ftb_start), cut = (Number(pr._ftb_cutoff) || 0) * 3600 * 1000;
        if (!(start - now >= cut && start > now)) stale[pr._ftb_ref || it.key] = true;
      });
      cart.items.forEach(function (it) {
        var pr = it.properties || {};
        if (stale[pr._ftb_ref || it.key]) { updates[it.key] = 0; any = true; }
      });
      if (!any) return false;
      return cartFetch('cart/update.js', { updates: updates }).then(function () { return true; });
    }).catch(function () { return false; });
  }
  window.FTBGuardCart = guardCart;

  /* ------------------------------------------------------------------ */
  var instances = [];

  /** FCT.open() opens the booking overlay at the calendar (used by the mobile bar). */
  window.FCT = window.FCT || {};
  window.FCT.open = function () {
    var w = instances[0];
    if (!w) return false;
    w.openModal('calendar');
    return true;
  };

  function boot() {
    var product = buildProduct();
    var nodes = document.querySelectorAll('.fct-widget:not([data-fct-ready])');
    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-fct-ready', '1');
      if (el.className.indexOf('fct-root') === -1) el.className += ' fct-root';
      if (CFG.brand) el.style.setProperty('--fct-brand', CFG.brand);
      if (!product || product.offline) {
        document.documentElement.classList.add('ftb-offline'); // keep the message visible on phones
        clear(el);
        el.appendChild(h('div', { class: 'fct-card' }, h('p', { class: 'fct-empty' }, product ? T.offline : T.loadError)));
        return;
      }
      instances.push(new Widget(el, product));
    });
    // The mobile bar works even if the page template has no visible widget.
    if (product && product.offline) product = null;
    if (product && !instances.length) {
      var hidden = h('div', { class: 'fct-root fct-widget', hidden: true });
      document.body.appendChild(hidden);
      instances.push(new Widget(hidden, product));
    }
    var bar = document.querySelector('[data-ftb-bar]');
    if (bar && product) {
      var min = Math.min.apply(null, product.tiers.map(function (t) { return t.adult; }));
      var from = bar.querySelector('[data-ftb-from]');
      if (from) from.textContent = shortPrice(min, product.currency);
      bar.removeAttribute('hidden');
      document.documentElement.classList.add('ftb-has-bar');
    }
    if (product) {
      var fromEls = document.querySelectorAll('[data-ftb-from]');
      var minAdult = Math.min.apply(null, product.tiers.map(function (t) { return t.adult; }));
      Array.prototype.forEach.call(fromEls, function (x) { x.textContent = shortPrice(minAdult, product.currency); });
    }
    // [data-ftb-open]: always opens the booking overlay at the calendar.
    // [data-ftb-open-mobile]: opens it only when the inline calendar is hidden (phones).
    Array.prototype.forEach.call(document.querySelectorAll('[data-ftb-open], [data-ftb-open-mobile]'), function (btn) {
      btn.addEventListener('click', function (e) {
        if (!instances.length || !instances[0].p) return;
        if (btn.hasAttribute('data-ftb-open-mobile')) {
          var inline = instances[0].root;
          if (inline.offsetParent !== null) return; // calendar visible: let the link scroll to it
        }
        e.preventDefault();
        window.FCT.open();
      });
    });
    guardCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
